class StCookieSettingsController {
    constructor($translate, cookiesConsent, CONFIG) {
        'ngInject';
        this.$translate = $translate;
        this.languages = CONFIG.languages;
        this.CookiesConsent = cookiesConsent;
        this.name = 'stCookieSettings';
    }

    $onInit() {
        let language = this.languages[this.$translate.use()];
        this.cookie_policy_note_href = `http://www.suntransfers.com${ language.key == 'en' ? '/' : '/' + language.key + '/' }terms-and-conditions#cookies_policy`;

        this.values = {
            link_start: '<a href="' + this.cookie_policy_note_href + '" target="_blank">',
            link_end: '</a>'
        };
    }

    allowAll() {
        this.CookiesConsent.setCookie('{"performance":true,"targeting":true}');
        this.closeCookie();
    }

    save() {
        this.CookiesConsent.setCookie('{"performance":' + document.getElementsByName('settings_performance')[0].checked + ',"targeting":' + document.getElementsByName('settings_marketing')[0].checked + ' }');
        this.closeCookie();
    }

    closeCookie() {
        document.getElementById('js-cookie-alert').classList.add('is-collapsed');
        this.close();
    }
}

export default StCookieSettingsController;



// WEBPACK FOOTER //
// ./client/app/common/stCookieSettings/stCookieSettings.controller.js